import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export type AppRole = "admin" | "instructor" | "mentor";

export function useUserRoles() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["user_roles", user?.id],
    queryFn: async () => {
      if (!user?.id) return [];

      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);

      if (error) throw error;
      return (data || []).map((r) => r.role as AppRole);
    },
    enabled: !!user?.id,
  });
}

export function useHasRole(role: AppRole) {
  const { data: roles } = useUserRoles();
  return roles?.includes(role) ?? false;
}
